import { isArray } from "lodash";
import moment from "moment";
import {
    EMPTY_STRING,
    NULL_VALUE,
    DEFAULT_DATE_TIME,
    DEFAULT_DATE_TIME_EMPTY,
} from '@Utils/constants'

// List of all Job Offer module Selectors
export const getDefaultFilters = ({ jobOfferList }) => jobOfferList.searchFilter;
export const getListPageTitle = ({ jobOfferList }) => jobOfferList.searchLabel;
export const getListAlertModal = ({ jobOfferList }) => jobOfferList.alert;
export const getListConfirmModal = ({ jobOfferList }) => jobOfferList.confirmModal;

// Table Selectors
export const getTableData = ({ jobOfferList }) => jobOfferList.resultTable.data;
export const getTableSelectedRows = ({ jobOfferList }) => jobOfferList.resultTable.selectedRows;
export const getTotalCount = ({ jobOfferList }) => jobOfferList.resultTable.totalCount;
export const getCurrentPage = ({ jobOfferList }) => jobOfferList.searchFilter.Pagination.Page;
export const getSortModel = ({ jobOfferList }) => jobOfferList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ jobOfferList }) => jobOfferList.resultTable.rowsPerPage;
export const isTableLoading = ({ jobOfferList }) => jobOfferList.resultTable.loading;

// Job Offer Add Form
export const getAddFormData = ({ jobOfferAdd }) => jobOfferAdd.addForm;
export const getAlertModelData = ({ jobOfferAdd }) => jobOfferAdd.alert;
export const getShowLoading = ({ jobOfferAdd }) => jobOfferAdd.loading;
export const hasLoadedData = ({ jobOfferAdd }) => jobOfferAdd.hasLoadedData;
export const getAddMode = ({ jobOfferAdd }) => jobOfferAdd.mode;
export const getAddEditable = ({ jobOfferAdd }) => jobOfferAdd.isEditable;
export const getInfoModalData = ({ jobOfferAdd }) => jobOfferAdd.info;
export const getConfirmModalData = ({ jobOfferAdd }) => jobOfferAdd.confirm;
export const getSyncConfrimModalData = ({ jobOfferAdd }) => jobOfferAdd.syncConfirm;

export const validateAddForm = (values, statusList) => {
    let errors = {};
    const discussionDateTime = moment(values.discussionDate, 'MM/DD/YYYY hh:mm:ss', true);
    const selectedStatus = statusList.find(status => status.value === values.jobOfferStatus);
    const statusName = selectedStatus ? selectedStatus.name : null;

    if (values.applicantID === 0) {
        errors[`applicantID`] = 'Applicant Name is required!'
    }

    if (
      statusName === "Approved" &&
      (values.discussionDate === DEFAULT_DATE_TIME ||
        values.discussionDate === DEFAULT_DATE_TIME_EMPTY ||
        values.discussionDate === "Invalid date" ||
        !values.discussionDate.trim())
    ) {
      errors[`discussionDate`] = "Discussion Date is invalid!";
    } else if (discussionDateTime.isSameOrBefore(moment())) {
      errors[`discussionDate`] =
        "Discussion Date cannot be same or before as current date";
    } 

    if (values.jobRate === '0.00' || values.jobRate === 0) {
        errors[`jobRate`] = 'Job Offer Rate is required!'
    }

    if (statusName === "Approved" && (values.f2FDetails === NULL_VALUE || EMPTY_STRING)) {
        errors['f2FDetails'] = 'Address or Link is required!'
    }

    return errors;
}

export const validateAddInfoForm = (values) => {
    let errors = {};
    const formattedBirthDate = moment(values.additionalInformation.birthDate).format('MM/DD/YYYY');
    const birthDates = moment(formattedBirthDate, 'MM/DD/YYYY', true);
    const accepted = values.applicantAcceptance

    if (values.additionalInformation.department === 0) {
        errors[`department`] = 'Department is required!'
        errors[`employeeInfo`] = true
    }

    if (values.additionalInformation.section === 0) {
        errors[`section`] = 'Section is required!'
        errors[`employeeInfo`] = true
    }

    if (values.additionalInformation.yearsOfIndustry.trim() === '') {
        errors[`yearsOfIndustry`] = 'Years of industry is required!'
        errors[`employeeInfo`] = true
    }

    if (!formattedBirthDate) {
        errors[`birthDate`] = 'Birth Date is required!';
        errors[`employeeInfo`] = true;
    } else if (!birthDates.isValid()) {
        errors[`birthDate`] = 'Birth Date must be in MM/DD/YYYY format!';
        errors[`employeeInfo`] = true;
    } else if (!/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/.test(formattedBirthDate)) {
        errors[`birthDate`] = 'Birth Date must be in MM/DD/YYYY format!';
        errors[`employeeInfo`] = true;
    } else if (birthDates.isSameOrAfter(moment())) {
        errors[`birthDate`] = 'Birth Date cannot be same or before as current date';
        errors[`employeeInfo`] = true;
    } else if (moment(values.additionalInformation.birthDate).isSame('0001-01-01T00:00:00')
        || moment(values.additionalInformation.birthDate).isSame('1753-01-01T00:00:00')) {
        errors['birthDate'] = 'Birth Date must not be Default!';
        errors[`employeeInfo`] = true;
    } else if (/[^0-9\/]/.test(formattedBirthDate)) {
        errors[`birthDate`] = 'Birth Date cannot contain letters!';
        errors[`employeeInfo`] = true;
    }

    if (values.additionalInformation.accessLevel.trim() === '') {
        errors[`accessLevel`] = 'Access level is required!'
        errors[`accountManage`] = true
    }

    if (values.additionalInformation.batchId.trim() === '') {
        errors[`batchId`] = 'Batch ID is required!'
        errors[`payrollInfo`] = true
    }

    if (values.additionalInformation.employeeClass.trim() === '') {
        errors[`employeeClass`] = 'Employee Class is required!'
        errors[`payrollInfo`] = true
    }
    return errors;
}
